import React from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

class MyUser extends React.Component {

    handleChangePassword = () => {
        this.props.showPopup("changePassword")
    }

    handleTeamList = () => {
        if (this.props.currentUser) {
            const list = this.props.currentUser.applicationUserTeams.map(x => x.team.name)
            return list.join(", ")
        }
    }


    render() {

        return (
            <div className="mainWrapper">
                <div className="bodyPart">
                    <div className="contentWrapper">
                        <h2 className="pageHead">
                            <AccountCircleIcon />
                            My User
                            <div className="rightButton">
                                <button className="btn" onClick={this.handleChangePassword}>
                                    Change Password
                                </button>
                            </div>
                        </h2>
                        <ul className="userdetails">
                            <li>
                                <label>First Name :</label>
                                <span>{this.props.currentUser && this.props.currentUser.firstName}</span>
                            </li>
                            <li>
                                <label>Last Name :</label>
                                <span>{(this.props.currentUser && this.props.currentUser.lastName) && this.props.currentUser.lastName.split(' ').join('')}</span>
                            </li>
                            <li>
                                <label>Email ID :</label>
                                <span>{this.props.currentUser && this.props.currentUser.email}</span>
                            </li>
                            <li>
                                <label>Company :</label>
                                <span>{this.props.currentUser && this.props.currentUser.customer.name}</span>
                            </li>
                            <li>
                                <label>Teams :</label>
                                <span>{this.handleTeamList()}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

}

export default MyUser
